import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dataLogin } from "../utils";
import { useValidateForm } from "../hooks/useValidateForm";
import { Footer, LoginFormFull } from "../Components";
import RoomIcon from "@mui/icons-material/Room";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Button, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function LoginChoice() {
  const { config } = useSelector((state) => state.user);
  // const [activeForm, setActiveForm] = useState("");

  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width: 960px)");

  const handleClick = () => {
    window.location.href = config.researchPageUrl;
  };

  const visibleForms = dataLogin.filter(
    (form) => config?.loginFormsVisibility?.[form.id] !== false
  );
  const onlyFormId = visibleForms.length === 1 ? visibleForms[0].id : null;

  // const [activeForm, setActiveForm] = useState(
  //   visibleForms.length === 1 ? visibleForms[0].id : ""
  // );
  const [activeForm, setActiveForm] = useState(onlyFormId || "");
  useEffect(() => {
    if (onlyFormId) {
      setActiveForm(onlyFormId);
    }
  }, [onlyFormId]);
  const { validateForm, toastVisible, lockMessage } = useValidateForm(
    config,
    activeForm
  );

  const toggleForm = (formId) => {
    if (onlyFormId) return;
    setActiveForm(activeForm === formId ? "" : formId);
  };
  return (
    <Fragment>
      <div
        className="login-choice-content"
        style={{
          ...(config.backgroundImage
            ? {
                backgroundImage: !isMobile
                  ? `url('${config.backgroundImagePath}')` || ""
                  : "",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }
            : {}),
          height: "100vh",
          marginBottom: isMobile ? 0 : "30px",
        }}
      >
        <div
          className="container"
          style={{
            marginTop: isMobile ? "5px" : "15px",
            marginBottom: isMobile ? "10px" : "80px",
            width: "fit-content",
            borderRadius: "10px",
            // backgroundColor: "transparent",
          }}
        >
          <div
            className="loginPage-info"
            style={{
              marginTop: isMobile ? 0 : "5px",
              marginBottom: isMobile ? 0 : "10px",
            }}
          >
            {config?.address?.length > 0 && (
              <div id="address" style={{ color: config.appBarColor }}>
                <RoomIcon
                  className="icon"
                  sx={{ color: config.footerBarColor, bgcolor: "#fff" }}
                />
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    config.address
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: config.footerBarColor,
                  }}
                >
                  Адрес: {config.address}
                </a>
              </div>
            )}
            {config?.phone?.length > 0 && (
              <div id="phone" style={{ color: config.appBarColor }}>
                <PhoneIcon
                  className="icon"
                  sx={{ color: config.footerBarColor, bgcolor: "#fff" }}
                />
                <a
                  href={`tel:${config.phone}`}
                  style={{ color: config.footerBarColor }}
                >
                  Телефон: {config.phone}
                </a>
              </div>
            )}

            {config?.email?.length > 0 && (
              <div id="email" style={{ color: config.appBarColor }}>
                <MailOutlineIcon
                  className="icon"
                  sx={{ color: config.footerBarColor, bgcolor: "#fff" }}
                />
                <a
                  href={`mailto:${config.email}`}
                  style={{ color: config.footerBarColor }}
                >
                  Имейл: {config.email}
                </a>
              </div>
            )}
          </div>
          {visibleForms.map((form) => (
            <LoginFormFull
              key={form.buttonId}
              buttonId={form.buttonId}
              // buttonOnClick={() => toggleForm(`${form.buttonOnClick}`)}
              buttonOnClick={() => toggleForm(form.id)}
              buttonText={form.buttonText}
              buttonIcon={form.buttonIcon}
              id={form.id}
              // visible={activeForm === form.visible || onlyFormId === form.id}
              visible={activeForm === form.id}
              onSubmit={() => validateForm(`${form.onSubmit}`)}
              errors={form.errors}
              inputs={form.inputs}
              placeholder={form.placeholder}
              onlyFormId={onlyFormId}
            />
          ))}
          {config?.buttonResearch && (
            <div className="belowloginformfull">
              <Button
                variant="text"
                onClick={handleClick}
                sx={{
                  textTransform: "none",
                  borderRadius: 1,
                  width: "100%",
                  height: isMobile ? "65px" : "100%",
                  maxWidth: "300px",
                  // width: isMobile ? "95%" : "65%",
                  backgroundColor: "#F6F6F8",
                  // backgroundColor: "red",
                  border: "1px solid transparent",
                  marginTop: "10px",
                  justifyContent: "flex-start",

                  "&:hover": {
                    backgroundColor: config?.buttonColors?.hover || "#C5D5EA",
                    border: `1px solid ${config.loginTextColor} !important`,
                  },
                  color: config.buttonInnerTextColor,

                  "& p": {
                    fontSize: "18px",
                    // fontWeight: "600",
                    marginLeft: "10px",
                  },
                }}
              >
                <p>Вход за проучвания</p>
              </Button>
            </div>
          )}
        </div>
        <Footer />
        {toastVisible && (
          <div id="toast" className="toast show">
            Неуспешен вход
          </div>
        )}
        {lockMessage && (
          <div id="lock-message" className="lock-message">
            {lockMessage}
          </div>
        )}
      </div>
    </Fragment>
  );
}
